import { render, staticRenderFns } from "./GlobalSearchResult.vue?vue&type=template&id=5f866697&scoped=true&"
import script from "./GlobalSearchResult.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchResult.vue?vue&type=style&index=0&id=5f866697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f866697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle})
